export const isPdfEncrypted = (arrayBuffer: ArrayBuffer): boolean => {
	const bytes = new Uint8Array(arrayBuffer);
	const chunk = new TextDecoder('latin1').decode(
		bytes.subarray(0, Math.min(bytes.length, 1024 * 1024))
	);
	return /\/Encrypt\s+\d+\s+\d+\s+R/.test(chunk);
};

export const hasPdfSignature = (arrayBuffer: ArrayBuffer): boolean => {
	const bytes = new Uint8Array(arrayBuffer);
	const header = new TextDecoder('latin1').decode(
		bytes.subarray(0, Math.min(bytes.length, 1024))
	);
	return header.includes('%PDF-');
};
